import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';
import ListItemAvatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemAvatar';
import ListItemText from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItemText';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useBlueprintContext } from 'Context/BlueprintContext';

import { actionItems as enumeratedValuesActionItems } from 'Consts/EnumeratedValues';
import RichTextDisplay from 'Components/UI/RichTextDisplay';

import { addQuery } from 'Helpers/Query';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';

const styles = () => ({
  content: {},
});

const ActionItems = ({
  actionItems,
  classes,
}) => { // eslint-disable-line arrow-body-style
  const { isReadOnly } = useBlueprintContext();
  const incompleteActionItems = actionItems.filter(actionItem => actionItem.attributes.status !== 'completed');
  return (
    <div className="action-items-list section">
      <div className="heading">
        <h4 className="bordered">Tasks</h4>
      </div>
      <List className={classes.content}>
        {incompleteActionItems.map((actionItem) => { // eslint-disable-line arrow-body-style
          return (
            <ListItem
              button={!isReadOnly}
              onClick={(isReadOnly) ? null : () => {
                addQuery({ todoId: actionItem.id });
                openModal(modalConsts.simpleActionItemModal);
              }}
            >
              {actionItem.attributes.priority !== '' && (
                <ListItemAvatar>
                  <span
                    className={`priority ${actionItem.attributes.priority}`}
                  >
                    {enumeratedValuesActionItems(
                      'priority',
                      actionItem.attributes.priority,
                    )}
                  </span>
                </ListItemAvatar>
              )}
              <ListItemText
                primary={`${actionItem.attributes.name} ${moment(actionItem.attributes.dueDate).format('MM/DD/YYYY')}`}
                secondary={
                  <RichTextDisplay
                    content={actionItem.attributes.description}
                  />
                }
              />
            </ListItem>
          );
        })}
        {incompleteActionItems.length === 0 && <div>No action items.</div>}
      </List>
    </div>
  );
};

ActionItems.propTypes = {
  actionItems: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ActionItems);
